import React from 'react';
import { Box } from '@mui/material';
import BaseModal from './common/BaseModal';

/**
 * @deprecated Use BaseModal instead for better mobile responsiveness and consistency
 * This component is kept for backwards compatibility but will be removed in a future version
 */
export const Modal = ({ open, onClose, children, hideCloseButton = false, disableBackdrop = false, ...props }) => {
  console.warn('Modal component is deprecated. Please use BaseModal for better mobile support and consistency.');
  
  if (!open) return null;

  return (
    <div>
      {/* Overlay - not rendered if disableBackdrop is true */}
      {!disableBackdrop && (
        <Box
          onClick={onClose}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            zIndex: 1000,
          }}
        />
      )}
      
      {/* Modal */}
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1001,
          width: '90%',
          maxWidth: '600px',
          ...props.sx
        }}
      >
        {/* Close button - only shown if hideCloseButton is false */}
        {!hideCloseButton && (
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              right: '10px',
              top: '10px',
              background: 'transparent',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              zIndex: 1002,
            }}
          >
            &times;
          </button>
        )}
        
        {children}
      </Box>
    </div>
  );
};

// Export BaseModal as the recommended replacement
export { default as BaseModal } from './common/BaseModal'; 